/**
 * Check if the error codes array contains a particular subset. Both arguments
 * need to be the same type.
 * @param errors all formatted errors returned from the API
 * @param codes the codes you want to check for
 */
export const errorsContainsOneOf = <T>(errors: T[], codes: T[]): boolean => {
  return errors.some((err) => codes.includes(err));
};
